import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';

import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

import { HelperService, HTTPService, DateService } from 'app/services';
import { datetimeFormat } from 'app/constants/date-time-format';

@Component({
  selector: 'app-add-campaign',
  templateUrl: './add-campaign.component.html',
  styleUrls: ['./add-campaign.component.scss'],
})
export class AddCampaignComponent implements OnInit {
  @ViewChild('startDateCalendarContainer')
  startDateCalendarContainer: ElementRef;

  date: any = {};
  time: Date = new Date(2000, 2, 10, 10, 30, 0);
  min = new Date();

  header: String = '';
  launchDate: any;
  endDate: any;
  constructor(
    private dynamicDialogRef: DynamicDialogRef,
    private dateService: DateService,
    private dialogConfig: DynamicDialogConfig,
    private helperService: HelperService,
    private httpService: HTTPService
  ) {}

  ngOnInit() {
    const data = this.helperService.deepCopy(this.dialogConfig.data);
    this.header = data.header;
    this.launchDate = data.launchDate;
    this.endDate = data.endDate;
    this.min = new Date();

    if (this.endDate) {
      this.min = new Date(this.launchDate);
      this.date = this.dateService.formatDate(new Date(this.endDate), datetimeFormat.mmmdyyyy);
      this.time = new Date(this.endDate);
    } else {
      this.date = this.dateService.formatDate(new Date(), datetimeFormat.mmmdyyyy);
      this.httpService.getServerTime().then(
        (serverTime: any) => {
          this.time = this.dateService.getCurrentDateTimeTz(serverTime);
          this.min = this.dateService.getCurrentDateTimeTz(serverTime);
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      );
    }
  }

  handleSubmit() {
    this.dynamicDialogRef.close({});
  }

  onSelectStartDate($event) {
    this.date = $event;
  }

  constructLaunchDateTime() {
    const date = this.dateService.formatDate(this.date, datetimeFormat.yyymmdd);
    const time = this.dateService.formatDate(this.time, datetimeFormat.hhmm);

    if (this.helperService.isAppleDevice()) {
      return new Date(this.dateService.madeDateStringIOSCompatible(`${date} ${time}`));
    } else {
      return new Date(new Date(`${date} ${time}`));
    }
  }

  updateTime() {
    const date = this.dateService.formatDate(this.date, datetimeFormat.yyymmdd);
    const time = this.dateService.formatDate(this.time, datetimeFormat.hhmm);
    this.time = new Date(this.dateService.madeDateStringIOSCompatible(`${date} ${time}`));
    return this.time;
  }

  /**
   * Close Modal
   * @param isSuccess
   */
  public handleClose(isSuccess: boolean = false): void {
    this.dynamicDialogRef.close({ isSuccess });
  }

  public handleSave(isSuccess: boolean = true): void {
    this.time = this.updateTime();
    var minDate = Date.parse(this.min.toString());
    var endDate = Date.parse(this.time.toString());
    if (minDate >= endDate) {
      this.helperService.showToaster('error', 'Campaign End date must be greater then Campaign Launch date');
      return;
    }
    this.dynamicDialogRef.close({
      isSuccess,
      data: { date: this.constructLaunchDateTime() },
    });
  }
}
